import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
// import { provideRoutes } from '@angular/router';
import {FormsModule} from '@angular/forms';
import {Http, HttpModule, RequestOptions} from '@angular/http';
// import { AUTH_PROVIDERS, JwtHelper } from 'angular2-jwt';
import {AuthHttp, AuthConfig, JwtHelper} from 'angular2-jwt';

import {AppComponent} from './app.component';
import {routing, appRoutingProviders, routedComponents} from './app.routing';
import {
    Store,
    StoreService,
    LocalService,
    MockApiService,
    CognitoAuthService,
    AlertService,
    ThreatService,
    EventService,
    LogService,
    DeviceService,
    RemoteHostsService,
    AutoRefreshService,
} from './shared';

import {FooterComponent, SideNavComponent, TopNavComponent} from './ui';
import {
    AlertsTableComponent,
    BubbleChartComponent,
    ColumnChartComponent,
    DevicesTableComponent,
    DeviceDetailComponent,
    DonutChartComponent,
    EventsTableComponent,
    GlossaryComponent,
    HighchartsComponent,
    HighRiskDevicesComponent,
    InsightGraphicComponent,
    InsightSummaryComponent,
    ModalComponent,
    PopoverComponent,
    RemoteHostsTableComponent,
    WeeklyColumnChartComponent,
    WeeklySummaryComponent,
    WorldMapChartComponent,
} from './components';
import {CustomerReportMobileComponent} from './containers/customer-report-mobile/customer-report-mobile.component';
import {CustomerReportComponent} from './containers/customer-report/customer-report.component';
import { IsoService } from './shared/iso/iso.service';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
    return new AuthHttp(new AuthConfig(), http, options);
}

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        routing
    ],
    declarations: [
        ...routedComponents,
        AppComponent,

        FooterComponent,
        SideNavComponent,
        TopNavComponent,

        AlertsTableComponent,
        BubbleChartComponent,
        DevicesTableComponent,
        DeviceDetailComponent,
        ColumnChartComponent,
        CustomerReportComponent,
        CustomerReportMobileComponent,
        DonutChartComponent,
        EventsTableComponent,
        GlossaryComponent,
        HighchartsComponent,
        HighRiskDevicesComponent,
        InsightGraphicComponent,
        InsightSummaryComponent,
        ModalComponent,
        PopoverComponent,
        RemoteHostsTableComponent,
        WeeklyColumnChartComponent,
        WeeklySummaryComponent,
        WorldMapChartComponent
    ],
    providers: [
        JwtHelper,
        Store,
        StoreService,
        LocalService,
        MockApiService,
        CognitoAuthService,
        AlertService,
        ThreatService,
        EventService,
        DeviceService,
        RemoteHostsService,
        LogService,
        AutoRefreshService,
        IsoService,
        appRoutingProviders,
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [Http, RequestOptions]
        }
        // AUTH_PROVIDERS
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    alertService: AlertService;

    constructor(alertService: AlertService) {
        this.alertService = alertService;
    }
}



// WEBPACK FOOTER //
// /app/src/app/app.module.ts